export default "__VITE_PUBLIC_ASSET__533c7358__"